import { render, staticRenderFns } from "./changeFee.vue?vue&type=template&id=db4f2f34&scoped=true&"
import script from "./changeFee.vue?vue&type=script&lang=js&"
export * from "./changeFee.vue?vue&type=script&lang=js&"
import style0 from "./changeFee.vue?vue&type=style&index=0&id=db4f2f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4f2f34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db4f2f34')) {
      api.createRecord('db4f2f34', component.options)
    } else {
      api.reload('db4f2f34', component.options)
    }
    module.hot.accept("./changeFee.vue?vue&type=template&id=db4f2f34&scoped=true&", function () {
      api.rerender('db4f2f34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/txPairManage/changeFee.vue"
export default component.exports